/* eslint-disable import/no-anonymous-default-export */
import http from "../../helpers/http";
import qs from 'qs'

export default {
    getCompany: (token, search, limit) => ({
        type: 'GET_COMPANY',
        payload: http(token).get(`/company/get?search=${search}&limit=${limit}`)
    }),
    getAllCompany: (token, search) => ({
        type: 'GET_ALLCOMPANY',
        payload: http(token).get(`/company/all?search=${search === undefined ? '' : search}`)
    }),
    addCompany: (token, data) => ({
        type: 'ADD_COMPANY',
        payload: http(token).post(`/company/add`, qs.stringify(data))
    }),
    updateCompany: (token, id, data) => ({
        type: 'UPDATE_COMPANY',
        payload: http(token).patch(`/company/update/${id}`, qs.stringify(data)),
    }),
    deleteCompany: (token, id, data) => ({
        type: 'DELETE_COMPANY',
        payload: http(token).delete(`/company/delete/${id}`, qs.stringify(data)),
    }),
    getDetailCompany: (token, id) => ({
        type: 'GET_DETAIL_COMPANY',
        payload: http(token).get(`/company/detail/${id}`)
    }),
    nextPage: (token, link) => ({
        type: 'NEXT_DATA_COMPANY',
        payload: http(token).get(`${link}`)
    }),
    resetError: () => ({
        type: 'RESET_COMPANY'
    })
}